import axios from 'axios'

// Module-level token store. Updated by ServiceProvider on each render so the
// interceptor always has a fresh token without needing React context inside the
// service layer.
let _currentToken: string | undefined

export function setApiToken(token: string | undefined) {
  _currentToken = token
}

export function getApiToken(): string | undefined {
  return _currentToken
}

export const wireApiClient = axios.create({
  baseURL: import.meta.env.VITE_SUPPORT_API_URL ?? 'https://support-api-rewire.com',
  headers: { 'Content-Type': 'application/json' },
})

wireApiClient.interceptors.request.use((config) => {
  if (_currentToken) {
    config.headers.Authorization = `Bearer ${_currentToken}`
  }
  return config
})

export const metricsApiClient = axios.create({
  baseURL: import.meta.env.VITE_METRICS_API_URL ?? 'https://metrics.api.whiteboardfederalrewired.com',
  headers: { 'Content-Type': 'application/json' },
})

metricsApiClient.interceptors.request.use((config) => {
  if (_currentToken) {
    config.headers.Authorization = `Bearer ${_currentToken}`
  }
  return config
})
